<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <h1 class="ts-uppercase ts-font-semibold ts-text-lg">
          {{ $t('studentEnrollment.promotionClass') }}
        </h1>

        <div class="ts-border-2 ts-border-dashed ts-rounded-md ts-mt-4 ts-p-4">
          <div class="row ts-space-y-2">
            <div class="col-md-12">
              <label class="required">{{
                $t('studentEnrollment.currentClass')
              }}</label>
              <treeselect
                :load-options="loadCurrentClass"
                :multiple="false"
                :options="currentClass"
                :placeholder="$t('select')"
                v-model.number="model.old_class_id"
                @select="value => (acp_id = value.acp_id)"
              />
              <div class="validate" v-if="errors.has('old_class_id')">
                {{ errors.first('old_class_id') }}
              </div>
            </div>
            <div class="col-md-12">
              <div class="ts-flex ts-items-center ts-justify-between">
                <label class="required">{{
                  $t('studentEnrollment.newClass')
                }}</label>
                <div class="ts-flex ts-mb-1">
                  <ts-checkbox
                    v-model="ac_status_id"
                    :value="1"
                    @change="loadForwardClass"
                    >{{ $t('invoice.current') }}</ts-checkbox
                  >
                  <ts-checkbox
                    class="ts-ml-3 ts-mr-3"
                    v-model="ac_status_id"
                    :value="3"
                    @change="loadForwardClass"
                    >{{ $t('invoice.next') }}</ts-checkbox
                  >
                </div>
              </div>
              <treeselect
                :multiple="false"
                :options="forwardClassOption"
                :disabled="!acp_id ? true : false"
                :placeholder="$t('select')"
                v-model.number="model.new_class_id"
              />
              <small
                ><i
                  >Take only class operation in next/current status and the next
                  grade of current class.</i
                ></small
              >
              <div class="validate" v-if="errors.has('new_class_id')">
                {{ errors.first('new_class_id') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-4">
          <div class="col-md-12">
            <div id="container-table">
              <ts-table
                :columns="columns"
                :records="resources"
                :loading="loading"
                :showCheckbox="true"
                @check-items="checkItem"
              >
                <template v-slot="{ record }">
                  <td>{{ record.student_profile.card_number }}</td>
                  <td>{{ record.student_profile.full_name_en }}</td>
                  <td>{{ record.student_profile.gender }}</td>
                  <td>{{ record.student_profile.phone }}</td>
                </template>
              </ts-table>
            </div>
            <div class="validate" v-if="errors.has('student_list')">
              {{ errors.first('student_list') }}
            </div>
          </div>
        </div>
        <div class="row ts-mt-4">
          <div class="col-md-12 text-right">
            <ts-button @click="$emit('close')" class="mr-2">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              color="primary"
              outline
              class="mr-2"
              :waiting="waiting_new"
              @click.prevent="storeStudentForwardNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="storeStudentForward"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { join } from 'lodash'

export default {
  name: 'classPromote',
  data() {
    return {
      model: {
        old_class_id: null,
        new_class_id: null,
        student_list: [],
        trans_type: 2
      },
      resources: [],
      loading: false,
      forwardClass: [],
      currentClass: null,
      acp_id: 0,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      ac_status_id: [3]
    }
  },
  computed: {
    columns() {
      return [
        { name: this.$t('studentEnrollment.studentCard') },
        { name: this.$t('studentEnrollment.studentName') },
        { name: this.$t('studentEnrollment.gender') },
        { name: this.$t('studentEnrollment.phone') }
      ]
    },
    forwardClassOption() {
      return this.forwardClass
        .filter(el => this.ac_status_id.includes(el.ac_status_id))
        .map(el => ({
          id: el.class_id,
          label: `${el.class_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}
                | ${el.batch_name}`
        }))
    }
  },
  methods: {
    ...mapActions('studentEnrollment', [
      'getClassOperation',
      'fetchStudentEnrollByClass'
    ]),
    filterStudent() {
      if (this.model.old_class_id != undefined) {
        this.loading = true
        this.fetchStudentEnrollByClass({
          page: -1,
          filter: {
            class_id: this.model.old_class_id
          }
        })
          .then(response => {
            this.resources = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.acp_id = 0
      }
    },
    checkItem(items) {
      this.model.student_list = items.map(el => el.student_id)
    },
    async loadCurrentClass({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        await this.getClassOperation({
          perPage: -1,
          filter: {
            ac_status_id: 1
          }
        })
          .then(response => {
            this.currentClass = response.data.map(el => ({
              acp_id: el.acp_id,
              id: el.class_id,
              label: `${el.class_name} | ${el.teacher_name}  
								| ${el.study_time}
								| ${el.ac_status_description}
                | ${el.ac_year}
								| ${el.term_name}
                | ${el.batch_name}`
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    storeStudentForward() {
      this.waiting = true
      this.$store
        .dispatch('studentEnrollment/storeStudentForward', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    storeStudentForwardNew() {
      this.waiting_new = true
      this.$store
        .dispatch('studentEnrollment/storeStudentForward', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    loadForwardClass() {
      this.options = null
      if (this.acp_id) {
        this.loading = true
        this.getClassOperation({
          filter: {
            acp_id: this.acp_id,
            ac_status_id: this.ac_status_id
              ? join(this.ac_status_id, ',')
              : undefined
          },
          old_class_id: this.model.old_class_id,
          trans_type: this.model.trans_type,
          perPage: -1
        })
          .then(response => {
            this.forwardClass = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => (this.loading = false))
      }
    },
    clearInput() {
      this.model = {
        old_class_id: null,
        new_class_id: null,
        student_list: []
      }
    }
  },
  watch: {
    'model.old_class_id': function() {
      this.model.student_list = []
      this.model.new_class_id = null
      this.resources = []
      this.filterStudent()
      this.loadForwardClass()
    }
  }
}
</script>
